import { render } from "./SlideVideo.vue?vue&type=template&id=4e920190&ts=true"
import script from "./SlideVideo.vue?vue&type=script&lang=ts"
export * from "./SlideVideo.vue?vue&type=script&lang=ts"

import "./SlideVideo.vue?vue&type=style&index=0&id=4e920190&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__